<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="onConfirm"
  >
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Nytt ärende
      </v-card-title>
      <OdocForm :locations="locations" :case-types="caseTypes" />
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn
          :disabled="disableConfirmButton"
          rounded
          type="submit"
          color="primary"
          :loading="pending"
        >
          Lägg till ärende
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import OdocForm from './form/OdocForm'
import CREATE_ODOC_CASE from '../graphql/createOdocCase.graphql'
import { get } from 'vuex-pathify'
import { getHost } from '@/config'

export default {
  name: 'OdocCreateModal',

  props: {
    locations: Array,
    caseTypes: Array
  },

  components: {
    OdocForm
  },

  data: () => ({
    valid: true,
    pending: false
  }),

  computed: {
    model: get('odoc/model'),

    isProduction() {
      return getHost() === 'arriva.guru'
    },

    disableConfirmButton() {
      // const validEmails = [
      //   'joy.marcher@arriva.se',
      //   'tobias.andersson@arriva.se',
      //   'marcus.svensson@arriva.se'
      // ]

      // const isValidEmail = validEmails.includes(
      //   this.$store.get('sso/user').mail.toLowerCase()
      // )

      // return isValidEmail ? false : this.isProduction

      return false
    }
  },

  methods: {
    async onConfirm() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.pending = true

      const payload = {
        name: this.model.name,
        description: this.model.description,
        event_date: this.model.event_date,
        locations: this.model.locations.map(x => ({
          location_guid: x
        })),
        case_categories: this.model.case_categories.map(x => {
          const caseCategory = {
            case_category_guid: '561d3509-1aae-491d-8506-d1bef0f0a88c',
            diary_plan_item_guid: x
          }

          if (this.isProduction) {
            caseCategory.case_category_guid =
              '103e7f9b-8a68-4a8e-844a-e21ccf0302e2'
          }

          return caseCategory
        }),
        custom_properties: []
      }

      if (this.model.prognos && this.model.prognos.length) {
        payload.custom_properties.push({
          custom_property_guid: 'b76dc68a-fa06-4af1-ae88-46ef071f88fa',
          value: this.model.prognos
        })
      }

      if (this.model.operator_beroende) {
        payload.custom_properties.push({
          custom_property_guid: 'fa81af33-fb40-4bc6-b109-6d9428463f0c',
          value: this.model.operator_beroende
        })
      }

      if (this.model.tur && this.model.tur.length) {
        payload.custom_properties.push({
          custom_property_guid: '95e0f8ed-2222-4755-8d19-79c7e37d2292',
          value: this.model.tur.join(',')
        })
      }

      if (this.model.sammanfattning && this.model.sammanfattning.length) {
        payload.custom_properties.push({
          custom_property_guid: '66991434-3235-45bb-8312-fee1103b1ec6',
          value: this.model.sammanfattning.join(',')
        })
      }

      payload.custom_properties.push({
        custom_property_guid: 'd60d6c4a-255d-4499-a7f9-a4cd63e14dd9',
        value: 'Arriva Sverige AB'
      })

      payload.custom_properties.push({
        custom_property_guid: '751ef0bd-05d9-4d72-b716-cbbe4a0fd154',
        value: '81'
      })

      payload.custom_properties.push({
        custom_property_guid: '3430a452-f64f-4dab-b502-18a2c5290096',
        value: '1420'
      })

      this.$store.dispatch('odoc/removeSelectedCase')

      await this.$apollo.mutate({
        mutation: CREATE_ODOC_CASE,
        variables: {
          payload
        }
      })
      this.$emit('reload', payload)
      this.$store.set('odoc/selectedCase', null)
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
      this.$store.dispatch('odoc/resetModel')
    }
  }
}
</script>
